import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faBars , faArrowsRotate , faLock , faUnlockKeyhole , faBell,
    faEye , faCheck , faCancel,faDeleteLeft

} from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
    faBars , faArrowsRotate , faLock , faUnlockKeyhole , faBell,
    faEye , faCheck , faCancel,faDeleteLeft
)

